import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useStorageStore = defineStore('storage', () => {
    const all = ref(null);
    const labels = ref(null);

    const actions = {
        search: (params) => axios.get('/api/v1/storages', { params }),
        storeStorage: (params) => axios.post('/api/v1/storages', params),
        updateStorage: (params) => axios.patch('/api/v1/storages/' + params.hash, params),
        generateBins: (params) => axios.post('/api/v1/storages/' + params.hash + '/bins', params),
    };

    return {
        all,
        labels,
        ...actions,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(useStorageStore.acceptHMRUpdate);
}
